import { render, staticRenderFns } from "./PolicyCard.vue?vue&type=template&id=217dbc44&lang=pug&"
import script from "./PolicyCard.vue?vue&type=script&lang=js&"
export * from "./PolicyCard.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCard.vue?vue&type=style&index=0&id=217dbc44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports